import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SitesListComponent } from './sites-list/sites-list.component';
import { SiteManageComponent } from './site-manage/site-manage.component';
import { SettingsComponent } from './site-manage/settings/settings.component';
import { PagesComponent } from './site-manage/pages/pages.component';
import { PageComponent } from './site-manage/pages/page/page.component';
import { ProfilesComponent } from './site-manage/profiles/profiles.component';
import { ProfileComponent } from './site-manage/profiles/profile/profile.component';
import { UsersComponent } from './site-manage/users/users.component';
import { NavigationComponent } from './site-manage/navigation/navigation.component';
import { RedirectsComponent } from './site-manage/redirects/redirects.component';
import { LoginComponent } from './auth/login/login.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { AcceptInviteComponent } from './auth/accept-invite/accept-invite.component';
import { authGuard } from './auth/auth.guard';
import { platformAdminGuard } from './auth/platform-admin.guard';
import { canManageUsersGuard } from './auth/can-manage-users.guard';
import { ArticlesComponent } from './site-manage/articles/articles.component';
import { ArticleComponent } from './site-manage/articles/article/article.component';
import { DomainsComponent } from './domains/domains.component';
import { AdminLayoutComponent } from './admin-layout/admin-layout.component';
import { PlatformUsersComponent } from './platform-users/platform-users.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent, data: { title: 'Sign in' } },
  { path: 'forgot-password', component: ForgotPasswordComponent, data: { title: 'Reset password' } },
  { path: 'accept-invite', component: AcceptInviteComponent, data: { title: 'Set password' } },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'sites', pathMatch: 'full' },
      { path: 'sites', component: SitesListComponent, data: { title: 'Sites' } },
      { path: 'domains', component: DomainsComponent, canActivate: [platformAdminGuard], data: { title: 'Domains' } },
      { path: 'users', component: PlatformUsersComponent, canActivate: [platformAdminGuard], data: { title: 'Users' } },
    ]
  },
  {
    path: 'sites/:url/manage',
    component: SiteManageComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'users', pathMatch: 'full' },
      { path: 'settings', component: SettingsComponent, canActivate: [canManageUsersGuard], data: { title: 'Settings' } },
      { path: 'pages', component: PagesComponent, data: { title: 'Pages' } },
      { path: 'pages/page', component: PageComponent, data: { title: 'Pages | New Page' } },
      { path: 'pages/page/:id', component: PageComponent, data: { title: 'Pages' } },
      { path: 'profiles', component: ProfilesComponent, data: { title: 'Profiles' } },
      { path: 'profiles/profile', component: ProfileComponent, data: { title: 'Profiles | New Profile' } },
      { path: 'profiles/profile/:id', component: ProfileComponent, data: { title: 'Profiles' } },
      { path: 'articles', component: ArticlesComponent, data: { title: 'Articles' } },
      { path: 'articles/article', component: ArticleComponent, data: { title: 'Articles | New Article' } },
      { path: 'articles/article/:id', component: ArticleComponent, data: { title: 'Articles' } },
      { path: 'users', component: UsersComponent, canActivate: [canManageUsersGuard], data: { title: 'Users' } },
      { path: 'navigation', component: NavigationComponent, data: { title: 'Navigation' } },
      { path: 'redirects', component: RedirectsComponent, data: { title: 'Redirects' } }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
